// extracted by mini-css-extract-plugin
export default {"container":"AdminLayout_container__fCMIS"};